import React from "react";
import { FormControl, Modal } from "react-bootstrap"
import { getNFeConfig, updateNFeConfig } from "../../../../api/nfe";
import Button from "../../../../_components/Button"
import Text from "../../../../_components/Text"
import LoadingInput from "../../../../_components/LoadingInput"
import { showSnackBar } from "../../../../utils";
import { toast } from "react-toastify"
export default class NFCeConfig extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            config: {},
            loading: false,
            modal: {
                show: false,
                title: "",
                description: ""
            }
        }
        this._updateNFeConfig = this._updateNFeConfig.bind(this)
        this._onChange = this._onChange.bind(this)
    }
    _getNFeConfig() {
        this.setState({ ...this, loading: true })
        getNFeConfig()
            .then(config => this.setState({ ...this, config, loading: false }))
            .catch(() => this.setState({ ...this, loading: false }))
    }
    _updateLocalStorage() {
        let branch = window.localStorage.getItem("easygestorweb_current_branch") || undefined
        if (branch) {
            branch = JSON.parse(branch)
            branch["fiscal_config"] = this.state.config
            window.localStorage.setItem("easygestorweb_current_branch", JSON.stringify(branch))
        }
    }
    _updateNFeConfig() {
        this.setState({ ...this, loading: true })
        const { config } = this.state
        if (!config.nfce_id_csc && config.nfce_csc_token) {
            config["nfce_id_csc"] = "00001"
        }
        updateNFeConfig(this.state.config)
            .then(data => {
                this._updateLocalStorage()
                let href = window.location.pathname
                const redirect = window.location.href = href
                if (window.location.search.includes("from=")) {
                    href = window.location.search.split("from=")[1]
                }
                toast.success("Configurações atualizadas", {
                    toastId: "update-nfce-settings-toast"
                })
                setTimeout(redirect, 3000)
            })
            .catch(error => {
                console.log(error);
                const modal = {
                    show: true,
                    title: "Oops...",
                    description: "Ocorreu um erro ao tentar salvar as configurações, por favor revise as informações e tente novamente daqui a pouco"
                }
                this.setState({ ...this, loading: false, modal })

            })
    }
    _onChange(e) {
        const { name: key, value } = e.target
        const { config } = this.state
        config[key] = value
        this.setState({ ...this, config })
    }
    componentDidMount() {
        this._getNFeConfig()
        window.scrollTo({ top: 0 })
    }

    render() {
        return <div className="container">
            <div className="row">
                <div className="col-12 py-2">
                    <h2>
                        Configurações para emissão de NFC-e
                    </h2>
                </div>
                <div className="col-md-4 col-xs-12">
                    <div className="form-group">
                        <div className="form-label">
                            <Text>
                                Número
                            </Text>
                            <small>
                                Número da NFC-e
                            </small>
                        </div>
                        <LoadingInput
                            loading={this.state.loading}
                            name="nfce_number"
                            onChange={this._onChange}
                            value={this.state.config.nfce_number}
                            disabled={this.state.loading}
                        />
                    </div>
                </div>
                <div className="col-md-4 col-xs-12">
                    <div className="form-group">
                        <div className="form-label">
                            <Text>
                                Série
                            </Text>
                            <small>
                                Série para emissão da NFC-e
                            </small>
                        </div>
                        <LoadingInput
                            loading={this.state.loading}
                            name="nfce_serie"
                            onChange={this._onChange}
                            value={this.state.config.nfce_serie}
                            disabled={this.state.loading}
                        />
                    </div>
                </div>
                <div className="col-md-4 col-xs-12">
                    <div className="form-group">
                        <div className="form-label">
                            <Text>
                                Modelo de impressão da DANFE
                            </Text>
                            <small>
                                Formato de impressão do arquivo DANFE
                            </small>
                        </div>
                        <FormControl
                            name="nfce_danfe_orientation"
                            as="select"
                            onChange={this._onChange}
                            disabled={this.state.loading}>
                            <option selected={this.state.config.nfce_danfe_orientation === "1"} value="1">Bobina Términa</option>
                            <option selected={this.state.config.nfce_danfe_orientation === "2"} value="2">A4</option>
                        </FormControl>
                    </div>
                </div>
                <div className="col-md-4 col-xs-12">
                    <div className="form-group">
                        <div className="form-label">
                            <Text>
                                ID
                            </Text>
                            <small>
                                00001 é o mais comum, mas é sempre bom confirmar o ID correto.
                            </small>
                        </div>
                        <LoadingInput
                            loading={this.state.loading}
                            maxLength={10}
                            name="nfce_id_csc"
                            onChange={this._onChange}
                            value={this.state.config.nfce_id_csc}
                            disabled={this.state.loading}
                        />
                    </div>
                </div>
                <div className="col-md-4 col-xs-12">
                    <div className="form-group">
                        <div className="form-label">
                            <Text>
                                Código CSC
                            </Text>
                            <small>
                                Código de Segurança do Contribuinte (CSC)
                            </small>
                        </div>
                        <FormControl
                            name="nfce_csc_token"
                            maxLength={200}
                            onChange={this._onChange}
                            value={this.state.config.nfce_csc_token}
                            disabled={this.state.loading}
                        />
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-12">
                    <Button
                        onClick={this._updateNFeConfig}
                        disabled={this.state.loading}>
                        Salvar configurações
                    </Button>
                </div>
            </div>
            <Modal show={this.state.modal.show}>
                <Modal.Header>
                    <Modal.Title>
                        <h2>
                            {this.state.modal.title}
                        </h2>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p className="lead">
                        {this.state.modal.description}
                    </p>
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={() => window.location.reload()}>
                        Fechar
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    }

}


// WEBPACK FOOTER //
// ./src/views/Fiscal/NFCe/config/index.jsx